export default "/template/resource//static/media/img_yinyongguanxi@2x.bec2ff07.png";